import { useEffect } from 'react';

type PaymentCallbackProps = {};

const PaymentCallback: React.FC<PaymentCallbackProps> = () => {
  useEffect(() => {
    // Extract transaction data from URL params
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    const status = urlParams.get('status'); // e.g., "paid", "failed"

    if (id && status) {
      // Send data to parent React app
      window.parent.postMessage(
        { type: 'payment_result', id, status },
        '*' // Replace '*' with your domain for production
      );
    }
  }, []);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Payment Completed</h1>
      <p>Please wait, your payment status is being processed...</p>
    </div>
  );
};

export default PaymentCallback;
